module.exports = __webpack_public_path__ + "static/media/morphos_back.29afbe31.png";